/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FolderDto } from '../models/FolderDto';
import type { FolderInput } from '../models/FolderInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FolderService {

    /**
     * @param version 
     * @returns FolderDto OK
     * @throws ApiError
     */
    public static getAllFolders(
version: string,
): CancelablePromise<Array<FolderDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Folder/All',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns FolderDto OK
     * @throws ApiError
     */
    public static getUserFolders(
version: string,
): CancelablePromise<Array<FolderDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Folder/User',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns FolderDto OK
     * @throws ApiError
     */
    public static createFolder(
version: string,
requestBody?: FolderInput,
): CancelablePromise<FolderDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Folder',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param folderId 
     * @param version 
     * @param requestBody 
     * @returns FolderDto OK
     * @throws ApiError
     */
    public static updateFolder(
folderId: number,
version: string,
requestBody?: FolderInput,
): CancelablePromise<FolderDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/Folder/{folderId}',
            path: {
                'folderId': folderId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param folderId 
     * @param version 
     * @returns FolderDto OK
     * @throws ApiError
     */
    public static deleteFolder(
folderId: number,
version: string,
): CancelablePromise<FolderDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/v{version}/Folder/{folderId}',
            path: {
                'folderId': folderId,
                'version': version,
            },
        });
    }

}
